<template>
    <svg
        width="193"
        height="193"
        viewBox="0 0 193 193"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.15" cx="96.5" cy="96.4053" r="75" fill="#C5BEDE" />
    </svg>
</template>
